import * as React from 'react'

import { ImageSelectSlider } from '@thg-commerce/enterprise-network/src/generated/graphql'
import {
  ImageSlider,
  ImageSelectSliderProps,
  ImageProps,
} from '@thg-commerce/enterprise-widget-image-select-slider'
import { ImageSelectCardPicture } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Types/ImageSelectCardPicture'

import { BaseWidgetProps } from '../types'

interface ImageSelectSlideWithChildren
  extends Omit<ImageSelectSlider, 'banners'> {
  banners: Omit<ImageSelectCardPicture, 'id' | 'query'>[]
}

export type ImageSelectSliderRendererProps = BaseWidgetProps &
  Omit<ImageSelectSlideWithChildren, 'id' | 'query'>

export const ImageSelectSliderRenderer = (
  props: ImageSelectSliderRendererProps,
) => {
  if (!props.banners?.length) {
    return null
  }

  const imageProps: ImageProps[] = props.banners.map((item) => ({
    picture: item.picture,
    thumbnail: {
      image: item.thumbnailImagePath,
      alt: item.altTextThumbnail || '',
      text: item.ImageInformationText || '',
    },
  }))

  const imageSelectSliderProps: ImageSelectSliderProps = {
    images: imageProps,
    title: props.titleText || '',
  }
  return <ImageSlider {...imageSelectSliderProps} />
}
